import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { rhythm } from "../utils/typography"

const Books = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`

const Post = styled.div`
  height: 175px;
  width: 125px;
  border-radius: 15px;
  background-image: url(${props => props.img.fluid.src});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: 20px;
  margin: 30px;
  display: flex;
  align-items: flex-end;
  flex-direction: row-reverse;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  transition: all 0.2s ease-in-out;
  h3,
  h4 {
    display: none;
  }
  :hover {
    background-color: rgba(0, 0, 0, 0.5);
    background-blend-mode: saturation;
    h3,
    h4 {
      display: block;
    }
  }
`

const PostText = styled.div`
  font-family: sans-serif;
  color: white;
  padding: 3px;
  width: 100%;
  /* background: black; */
  h3 {
    font-family: sans-serif;
    font-size: 14px;
    max-height: 90px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  h4 {
    margin: 0;
    font-size: 8px;
    color: white;
  }
`

class BookList extends React.Component {
  render() {
    const { books } = this.props

    return (
      <Books>
        {books.map(({ node }) => {
          const title = node.title
          return (
            <Post key={node.slug} img={node.image}>
              <a style={{ boxShadow: `none` }} href={node.url} target="_blank">
                <PostText>
                  <h3
                    style={{
                      marginTop: 0,
                      marginBottom: rhythm(1 / 4),
                    }}
                  >
                    {title}
                  </h3>
                  <h4>by {node.author}</h4>
                </PostText>
              </a>
            </Post>
          )
        })}
      </Books>
    )
  }
}

export default BookList
